import React, { useCallback, useRef } from 'react'

import { CareersContainerStyled } from './styles'
import { CareersProps } from './types'

const Careers: React.FC<CareersProps> = ({ data }) => {
  const scriptRef = useRef<HTMLScriptElement>()
  const { containerAttrs, script } = data

  const handleScriptContainerRef = useCallback(
    (node) => {
      if (!node || !script || !!scriptRef.current) {
        return
      }

      scriptRef.current = document.createElement('script')

      scriptRef.current.onload = () => {
        document.dispatchEvent(new Event('readystatechange'))
      }

      for (const [key, value] of Object.entries(script)) {
        scriptRef.current.setAttribute(key, value)
      }

      node.appendChild(scriptRef.current)
    },
    [script]
  )

  return (
    <CareersContainerStyled
      id={containerAttrs.id}
      data-domain={containerAttrs.domain}
      data-version={containerAttrs.version}
      data-departmentId={containerAttrs.departmentId}
      ref={handleScriptContainerRef}
    ></CareersContainerStyled>
  )
}

export default Careers
